function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classnames from 'classnames';
import { variables } from 'swag-client-common/styles/variables-js';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import { Placement } from 'swag-client-common/constants';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { popperProps } from 'swag-client-common/components/partials/header-icons/header-icons';
import { TimeTable } from '../time-table';
import classes from './time-table-with-embellishment.scss';
export const TimeTableWithEmbellishment = _ref => {
  let {
      onChange,
      selectedEmbellishmentMethod,
      productSettings,
      prodTime,
      isLimitedEdition
    } = _ref,
    rest = _objectWithoutProperties(_ref, ["onChange", "selectedEmbellishmentMethod", "productSettings", "prodTime", "isLimitedEdition"]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, productSettings === null || productSettings === void 0 ? void 0 : productSettings.map(({
    embellishmentMethod,
    productionTimeList
  }, index) => {
    if (!embellishmentMethod) {
      return null;
    }
    const isActive = selectedEmbellishmentMethod === embellishmentMethod._id;
    const prodTimeForCurrentEmbellishment = isActive ? prodTime : -1;
    return /*#__PURE__*/React.createElement("div", {
      "data-block": embellishmentMethod.name,
      className: classnames(classes.container, {
        [classes.grey]: !(index % 2)
      }),
      key: embellishmentMethod.name
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.heading
    }, embellishmentMethod.name, embellishmentMethod.tooltip && /*#__PURE__*/React.createElement(Tooltip, {
      title: embellishmentMethod.tooltip,
      mode: "light",
      placement: Placement.RIGHT,
      className: classes.tooltip,
      PopperProps: popperProps
    }, /*#__PURE__*/React.createElement(InfoIcon, {
      iconColor: isLimitedEdition ? variables.colorOrange : variables.colorPrimary,
      className: classes.infoIcon
    }))), /*#__PURE__*/React.createElement(TimeTable, _extends({}, rest, {
      isLimitedEdition: isLimitedEdition,
      timeList: productionTimeList,
      prodTime: prodTimeForCurrentEmbellishment,
      onChange: prodTimeId => onChange(embellishmentMethod._id, prodTimeId)
    })));
  }));
};